﻿import ActivePage from "../activePage";

export default class AMSRemindersPage extends ActivePage {

    constructor() {
        super();
    }

    initializeSearchResultPage(searchResultPage) {
        searchResultPage.showBreadCrumbTrail = true;
        super.initializeSearchResultPage(searchResultPage);
        
        const page = $(searchResultPage.container);
        page.find(".print-recipients").on("click", (e) => {
            this.printRecipients(e);
        });
        page.find(".send-reminder").on("click", (e) => {
            this.sendReminder(e);
        });
    }

    searchResultGridDataBound = (e) => {
        const data = e.sender.dataSource.data();
        const grid = e.sender.element;

        if (data.length > 0) {
            grid.find(".reminder-option").on("click", (e) => {
                this.setReminderOption(e);
            });

            grid.find(".portfolio-review").on("click", (e) => {
                this.openPortfolioreview(e);
            });
        }
    }

    openPortfolioreview(e) {
        const el = $(e.target);
        const grid = el.closest(".kendo-Grid").data("kendoGrid");
        const item = grid.dataItem(el.closest("tr"));
        const form = el.closest("form");

        const url = form.data("portfolio-review-url");
        if (url) {
            const filters = [];

            filters.push({
                property: "AMSMain.CPIClient",
                operator: "",
                value: item.ClientCode
            });

            if (el.data("prepay") == "1") {
                filters.push({
                    property: "IncludeInstructed",
                    operator: "",
                    value: el.data("prepay")
                });
            }

            const data = {
                mainSearchFilters: filters,
                __RequestVerificationToken: form.find("input[name=__RequestVerificationToken]").val()
            };

            cpiLoadingSpinner.show();

            $.post(url, data)
                .done(function (html) {
                    cpiLoadingSpinner.hide();
                    pageHelper.appendPage(html);
                })
                .fail(function (error) {
                    cpiLoadingSpinner.hide();
                    pageHelper.showErrors(error);
                });

        }
    }

    setReminderOption(e) {
        const el = $(e.target);
        const grid = el.closest(".kendo-Grid").data("kendoGrid");
        const item = grid.dataItem(el.closest("tr"));
        const form = el.closest("form");

        const url = form.data("save-reminder-option-url");
        if (url) {
            const option = el.data("option");
            const value = !item[option];
            const data = {
                clientContactID: item.ClientContactID,
                option: option,
                value: value,
                tStamp: item.tStamp,
                __RequestVerificationToken: form.find("input[name=__RequestVerificationToken]").val()
            };

            cpiLoadingSpinner.show();

            $.post(url, data)
                .done(function (result) {
                    cpiLoadingSpinner.hide();

                    item[option] = value;
                    item.tStamp = result.tStamp;

                    if (value) {
                        el.addClass("fa-check-square");
                        el.removeClass("fa-square");
                    }
                    else {
                        el.removeClass("fa-check-square");
                        el.addClass("fa-square");
                    }

                    //pageHelper.showSuccess(result.message);
                })
                .fail(function (error) {
                    cpiLoadingSpinner.hide();
                    pageHelper.showErrors(error);
                });

        }
    }

    //todo
    printRecipients = (e) => {
        const el = $(e.target);
        const searchForm = $(this.refineSearchContainer);
        const url = el.data("url");
        const tokenUrl = el.data("token-url");
        const username = el.data("username");
        const downloadName = el.data("download-name");

        if (url) {
            pageHelper.callWithAuthToken(tokenUrl, username, function (authToken) {
                const data = pageHelper.formDataToJson(searchForm);
                pageHelper.fetchReport(url, {
                    criteria: data.payLoad,
                    token: authToken
                }, data.verificationToken, downloadName);
            });
        }
    }

    sendReminder = (e) => {
        const el = $(e.target);
        const url = el.data("url");
        const tokenUrl = el.data("token-url");
        const username = el.data("username");
        const grid = this.searchResultGrid.data("kendoGrid");
        const form = $(this.refineSearchContainer);
        const token = form.find("input[name='Token']");

        const send = () => {
            cpiLoadingSpinner.show();
            const data = pageHelper.gridMainSearchFilters(form);
            token.val("");
            $.post(url, data)
                .done(function (result) {
                    cpiLoadingSpinner.hide();
                    grid.dataSource.read().then(function () {
                        pageHelper.showSuccess(result.message);
                    });
                })
                .fail(function (error) {
                    cpiLoadingSpinner.hide();
                    grid.dataSource.read().then(function () {
                        pageHelper.showErrors(error);
                    });
                });
        };

        if (url) {
            cpiStatusMessage.hide();

            cpiConfirm.confirm(window.cpiBreadCrumbs.getTitle(), el.data("confirm-message"), function () {
                if (tokenUrl) {
                    pageHelper.callWithAuthToken(tokenUrl, username, function (authToken) {
                        //set token value
                        token.val(authToken);

                        send();
                    });
                }
                else {
                    send();
                }

            },
                {
                    "action": { "class": "btn-primary", "label": el.data("label-send"), "icon": "fa fa-share" },
                    "close": { "class": "btn-secondary", "label": el.data("label-cancel"), "icon": "fa fa-undo-alt" }
                }
            )
        }
    }
}